module.exports = __webpack_public_path__ + "media/images/flags/32/Indonesia-7e7483fe3d1bbc645e8a82ddb605ef5f.png";